// extracted by mini-css-extract-plugin
export default {"h4":"OverwriteProfile_h4__DogA0","modal":"OverwriteProfile_modal__gOWMK","modalDialog":"OverwriteProfile_modalDialog__Lw-Ml","button":"OverwriteProfile_button__KFul1"};